import { render, staticRenderFns } from "./GrowersSettlementData.vue?vue&type=template&id=3d9befe8"
import script from "./GrowersSettlementData.vue?vue&type=script&lang=js"
export * from "./GrowersSettlementData.vue?vue&type=script&lang=js"
import style0 from "./GrowersSettlementData.vue?vue&type=style&index=0&id=3d9befe8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports